var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 508.33 508.36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            /* Make the white background partially transparent */\n            .cls-1 {\n                fill: rgba(255, 255, 255, 0); /* 30% opacity */\n                fill-rule: evenodd;\n            }\n\n            /* Keep the black parts fully opaque */\n            .cls-2 {\n                fill: #000000;\n            }\n        "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M485,29.72c11.45,15.13,16.61,40.21,19.15,70.7,3.36,45.5,4.71,100.1,6,156.52-1.67,57.47-2.35,115.43-6,156.52-2.88,31.54-9,52.66-19.22,65.47-13,12.79-37.94,23.59-73.5,26.15-43.25,3.69-96.61,3.65-155.48,5.1-65.44-1.12-109.82-.64-156.38-5.08-36.32-2.52-60.08-13.19-74.7-26.07-10.83-14.54-14-30-17-66.24-3.75-41.85-4.58-98.56-6-155.54C4,200.57,4.13,143.44,7.9,100.74,10.43,67.05,14.42,44.4,24.65,30,39,17.77,63.48,11.69,100,8.69c50-5.85,102.06-7,155.88-6.87,55.39.09,108.56,1.67,156,6.34,32,2.56,58.48,8.07,73.07,21.56Z",
    transform: "translate(-1.83 -1.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.83,102.87a149.85,149.85,0,0,0-47.37,292c7.49,1.39,10.24-3.25,10.24-7.21,0-3.57-.14-15.38-.2-27.9C170.81,368.83,162,342.09,162,342.09c-6.82-17.32-16.64-21.92-16.64-21.92-13.6-9.3,1-9.11,1-9.11,15,1.06,23,15.44,23,15.44,13.36,22.9,35.05,16.28,43.6,12.45,1.34-9.68,5.23-16.29,9.51-20-33.28-3.79-68.27-16.64-68.27-74a58,58,0,0,1,15.44-40.22c-1.56-3.78-6.68-19,1.45-39.65,0,0,12.58-4,41.21,15.36a142.09,142.09,0,0,1,75,0C316,161,328.53,165,328.53,165c8.16,20.64,3,35.88,1.47,39.65a57.87,57.87,0,0,1,15.42,40.22c0,57.55-35.05,70.22-68.42,73.93,5.37,4.65,10.16,13.77,10.16,27.75,0,20-.17,36.18-.17,41.12,0,4,2.7,8.66,10.29,7.19a149.85,149.85,0,0,0-47.45-292Z",
    transform: "translate(-1.83 -1.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.75,318c-.33.75-1.5,1-2.57.46s-1.7-1.5-1.34-2.25,1.49-1,2.58-.47,1.71,1.51,1.33,2.26Z",
    transform: "translate(-1.83 -1.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.82,324.76c-.71.66-2.11.35-3.06-.69s-1.16-2.44-.44-3.11,2.09-.35,3.07.69,1.17,2.44.43,3.11Z",
    transform: "translate(-1.83 -1.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.73,333.39c-.92.64-2.42,0-3.35-1.29s-.92-2.93,0-3.57,2.41-.06,3.35,1.26.92,3,0,3.61Z",
    transform: "translate(-1.83 -1.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.82,341.73c-.82.91-2.57.66-3.85-.57s-1.67-2.92-.85-3.83,2.59-.65,3.88.57,1.7,2.93.82,3.83Z",
    transform: "translate(-1.83 -1.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188,346.57c-.36,1.17-2,1.71-3.74,1.21s-2.8-1.89-2.46-3.07,2-1.74,3.75-1.2,2.8,1.88,2.45,3.07Z",
    transform: "translate(-1.83 -1.82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.25,347.47c0,1.24-1.4,2.26-3.18,2.28s-3.24-1-3.26-2.18,1.41-2.26,3.2-2.29,3.24,1,3.24,2.19Z",
    transform: "translate(-1.83 -1.82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.66,345.52c.21,1.2-1,2.44-2.79,2.77s-3.35-.43-3.57-1.62,1-2.47,2.78-2.79,3.36.42,3.58,1.64Z",
    transform: "translate(-1.83 -1.82)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubBlack);
export default __webpack_public_path__ + "static/media/github_black.5fd8d72963093ad01b160177189553ff.svg";
export { ForwardRef as ReactComponent };